module.exports = "/templates/targettemplates.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/targettemplates.html
// module id = 465
// module chunks = 0